<template lang="pug">
	.domains-list
		.header
			button.btn.btn-primary(type="button" v-on:click="createNewWebsiteDomain")
				span New domain
				i.fa.fa-plus(:style="{'margin-left': '10px'}")
		.body
			.body-loaded(v-if="state === 'loaded'")
				.search-wrapper(v-show="websitesDomains.length")
					i.fa.fa-search
					input(placeholder="Filter domains" v-model="domainFilter")
					i.fa.fa-remove(v-show="domainFilter.length" @click="domainFilter = ''")
				.website-domain-wrapper(v-for="websiteDomain in this.filterWebsitesDomains()" :ref="'websiteWrapper-' + websiteDomain.domain")
					.top-part
						.left-part
							.actions-button(@click="showActionsDomain(websiteDomain.domain, $refs['websiteWrapper-' + websiteDomain.domain][0])" v-pseudo-modal-show="'domain-actions-dropdown'")
								i.icons.cui-options
							a.website-domain(target="_blank" :href="'https://' + websiteDomain.domain") {{websiteDomain.domain}}
						.right-part
							i.icon-button.bi.bi-braces(v-b-tooltip.hover="{delay: { show: 0, hide: 100 }, title: 'Edit JSON'}" @click="Broadcast.call('Show Json Editor', [websiteDomain.domain]);")
							i.icon-button.bi.bi-filetype-css(v-b-tooltip.hover="{delay: { show: 0, hide: 100 }, title: 'Edit CSS'}" @click="Broadcast.call('Show Css Editor', [websiteDomain.domain]);")
						//.right-part(v-show="websiteDomain.last_updated")
							.top-part
								.timestamp
									i.bi.bi-filetype-css
									span {{websiteDomain.last_updated ? dayjs(websiteDomain.last_updated).add(timezoneOffset, 'hour').format('HH:mm MMM-DD') : ''}}
									i.fa.fa-clock-o
							.bottom-part
								.timestamp
									i.bi.bi-braces
									span {{websiteDomain.last_updated ? dayjs(websiteDomain.last_updated).add(timezoneOffset, 'hour').format('HH:mm MMM-DD') : ''}}
									i.fa.fa-clock-o
			.modal-error(v-else-if="state === error")
				span {{error}}
			.modal-fetching(v-else)
				i.fa.fa-spinner.fa-spin
</template>
<script>
	import Screen 				from './../../mixins/screen';
	import dayjs 				from "dayjs";

	export default {
		name: 'DomainsList',
		mixins: [Screen],
		components: {},
		screen: {
			updateOn: [],
			events: {
				'Websites Domains Results': function (error, results) {
					if (error) {
						this.error = error;
						return;
					}

					this.state = 'loaded';

					this.websitesDomains = results;
				},
				'Remove Website Domain': function (domain) {
					if (!domain) return;

					const websiteDomain = this.websitesDomains.find(websiteDomain => websiteDomain.domain === domain);
					if (!websiteDomain) return;

					const websiteDomainIndex = this.websitesDomains.indexOf(websiteDomain);
					if (websiteDomainIndex < 0) return;

					this.state = 'fetching';
					setTimeout(() => {
						this.websitesDomains.splice(websiteDomainIndex, 1);
						this.state = 'loaded';
					}, 500);

				},
				'Add Website Domain': function (websiteDomain) {

					this.state = 'fetching';
					setTimeout(() => {
						this.websitesDomains.push(websiteDomain);
						this.websitesDomains = this.websitesDomains.sort((a, b) => a.domain.localeCompare(b.domain, undefined, { sensitivity: 'base' }));
						this.state = 'loaded';
					}, 500);

				},
				'Upload Website Domain': function (websiteDomain) {

					if (!websiteDomain) return;

					for (let i = 0; i < this.websitesDomains.length; i++) {
						if (this.websitesDomains[i].domain === websiteDomain.domain) {
							this.websitesDomains[i] = websiteDomain;
							return;
						}
					}

				}
			}
		},
		data() {
			this.timezoneOffset = ((new Date()).getTimezoneOffset()) / 60;
			this.dayjs = dayjs;

			this.Broadcast = Broadcast;

			return {
				error: '',
				state: 'fetching',
				domainFilter: '',
				showed: true
			}
		},
		watch: {
			domainFilter(value) {
			}
		},
		methods: {
			collectData() {

				this.error = '';
				this.state = 'fetching';

				this.websitesDomains = [];
				this.websitesDomainsFiltered = [];

				Server.sendToSocket({
					GetWebsitesDomains: {}
				});

			},
			close() {
				this.hide();
			},
			createNewWebsiteDomain() {
				Broadcast.call("Show Actions Create New Website Domain");
			},
			showActionsDomain(domain, wrapper) {
				Broadcast.call("Show Actions Domain", [domain, wrapper]);
			},
			filterWebsitesDomains() {

				if (!this.domainFilter.length) return this.websitesDomains;

				return this.websitesDomains.filter(websiteDomain => websiteDomain.domain.includes(this.domainFilter));

			}
		}

	}
</script>

<style lang="sass">

	.domains-list

		.css-input
			position: absolute
			left: 0
			top: 0
			transform: scale(0.1)
			visibility: hidden

		>.header
			display: flex
			justify-content: center

			>button
				width: 75%
				margin: 10px 0

		.body
			display: flex
			justify-content: center

		.body-loaded
			background: #3a4149
			width: 100%

			>.search-wrapper
				display: flex
				justify-content: center
				align-items: center
				padding: 5px 10px 5px 10px
				gap: 15px
				border-top: 1px solid #23282c

				>input
					width: 100%
					border: none
					background: unset
					outline: none
					padding-left: 5px
					color: white

					&:focus-visible
						border: none

				>i
					font-size: 120%
				>i.fa-remove
					cursor: pointer
					&:hover
						color: red
						transition: color 0.25s

			::-webkit-scrollbar
				width: 10px
				margin-left: -10px
				-webkit-appearance: none
				appearance: none

			::-webkit-scrollbar-thumb
				height: 50px
				background-color: rgba(255,255,255,0.2)
				background-clip: content-box
				border-color: transparent
				border-style: solid
				border-width: 1px 2px
				border-radius: 5px

			>.website-domain-wrapper
				height: 48px
				color: white
				display: flex
				flex-direction: column
				justify-content: center
				align-items: start
				padding-left: 1rem
				padding-right: 1rem
				font-size: 0.875rem
				border-bottom: 1px solid #23282c

				&:nth-of-type(2)
					border-top: 1px solid #23282c

				>.top-part
					display: flex
					flex-direction: row
					align-items: center
					gap: 15px
					width: 100%
					justify-content: space-between


					i
						cursor: pointer

				>.bottom-part
					display: flex
					flex-direction: row
					width: 100%
					justify-content: space-between

				&:hover
					.right-part
						display: flex

				.left-part, .right-part
					display: flex
					flex-direction: row
					gap: 15px
					overflow: hidden

					>a
						white-space: nowrap
						text-overflow: ellipsis
						overflow: hidden

					>.icon-button
						cursor: pointer
						margin: 0 10px 0 10px
						font-size: 20px

				.right-part
					display: none

				.timestamp
					font-size: 85%
					display: flex
					flex-direction: row
					gap: 10px
					align-items: center
					justify-content: end
					border-radius: 15px
					overflow: hidden
					white-space: nowrap

					>.modal-footer
						border: none
						justify-content: space-between
						padding: 5px 1rem 1rem 1rem
</style>
